
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["monthReport_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M569.6 115.2V0H454.4v115.2H0v115.2h57.6v576H416L192 979.2l38.4 44.8 275.2-224 275.2 224 38.4-44.8L601.6 800h364.8V224h57.6V115.2H569.6zm339.2 627.2H115.2v-512h793.6v512zM281.6 627.2V454.4h172.8c0-83.2-70.4-147.2-153.6-147.2-83.2 0-153.6 70.4-153.6 153.6 6.4 83.2 51.2 166.4 134.4 166.4zm57.6 57.6c89.6 0 172.8-89.6 172.8-172.8H339.2v172.8zm454.4-345.6H627.2v57.6H800v-57.6zm0 115.2H627.2V512H800v-57.6zm0 115.2H627.2v57.6H800v-57.6z"}})])
          )
        }
      }
    